import React from 'react';
import './toast-message.scss';

export interface IToastMessageProps {
   type: 'success' | 'error';
   headerText: string;
   bodyText: string;
   toastClass: string;
   setToastClass: React.Dispatch<React.SetStateAction<string>>;
}

export default function ToastMessage(props: IToastMessageProps): JSX.Element {
   const badgeViolationSvg = new URL(
      '/public/images/badge-violation.svg',
      import.meta.url
   );
   const badgeSuccessSvg = new URL(
      '/public/images/badge-success.svg',
      import.meta.url
   );
   return (
      <div className={`toast-message ${props.toastClass} ${props.type}`}>
         <div className="toast-message-nav-wrapper">
            <img src={props.type === 'error' ? badgeViolationSvg.toString() : badgeSuccessSvg.toString()} />
            <div className="toast-message-header label-xsmall">
               {props.headerText}
            </div>
            <div
               className="toast-message-back body-standard-semibold back-arrow"
               onClick={() => props.setToastClass('toast-hidden')}
            ></div>
         </div>
         <div className="toast-message-body body-small-regular">
            {props.bodyText}
         </div>
      </div>
   );
}
